import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import ArticleGrid from './components/ArticleGrid';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51fun吃瓜黑料不打烊',
    url: 'http://oheaven.cn/',
    description: '黑料吃瓜在线吃瓜实时追踪网红翻车、明星八卦。吃瓜黑料今日吃瓜，黑料爆料在线吃瓜，24小时黑料吃瓜不间断，热点全覆盖。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://oheaven.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51fun吃瓜黑料不打烊',
    url: 'http://oheaven.cn/',
    description: '黑料吃瓜 - 51fun吃瓜黑料不打烊，24小时不间断吃瓜黑料资讯平台',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <ArticleGrid />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}